var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.content.image
      ? _c("div", [
          _c("img", {
            staticClass: "img-responsive post-title",
            attrs: { src: _vm.content.image, alt: _vm.content.title },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.content.textType === "Marked"
      ? _c("div", {
          staticStyle: { padding: "20px" },
          domProps: { innerHTML: _vm._s(_vm.compiledMarkdown) },
        })
      : _vm.content.textType === "Html"
      ? _c("div", { domProps: { innerHTML: _vm._s(_vm.content.text) } })
      : _vm.content.textType === "Textuality"
      ? _c("div", { staticStyle: { padding: "20px" } }, [
          _c("p", [_vm._v(_vm._s(_vm.content.text))]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }